import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Seo from '../components/seo/Seo';
import { ArrowUpRight } from '../components/ui/icons/ArrowUpRight';
export default function NotFound() {
  const { i18n } = useTranslation();
  const fr = i18n.language.startsWith('fr');
  const title = fr ? 'Page introuvable' : 'Page not found';
  return (
    <section
      style={{ maxWidth: 1240, margin: '0 auto', padding: '200px 24px 140px' }}
    >
      <Seo
        title={`${title} | SOR SEO`}
        description={title}
        robots="noindex,follow"
      />
      <p>404</p>
      <h1>{title}</h1>
      <Link to={fr ? '/fr' : '/'}>
        {fr ? 'Retour à l’accueil' : 'Back to home'} <ArrowUpRight />
      </Link>
    </section>
  );
}
